// 3rd Party References
import * as React from 'react';
import { hot } from 'react-hot-loader';

// Utility References
import { Handler } from 'Utility/IndexOfActions';
import { StringHelper } from 'Utility/IndexOfHelpers';

// Local References
import InternalCommonTextInput, { IInternalCommonTextInputProps } from '../Inputs/Internal/InternalCommonTextInput';

interface ISimplePostalCodeInputProps {
    isDisabled?: boolean;
    isHidden?: boolean;
    onBlurCallback?: Handler.InputFocusEvent;
    onChangeCallback: Handler.StringProperty;
    onKeyPressCallback?: Handler.InputKeyboardEvent;
    onValidationFailure: Handler.Action;
    placeholder?: string;
    propertyName?: string;
    regexPattern: string;
    tabIndex?: number;
    value: string;
}

class SimplePostalCodeInput extends React.Component<ISimplePostalCodeInputProps, {}>{

    private primaryInput: InternalCommonTextInput;

    public setFocus = (scroll?: number): void => {
        this.primaryInput.setFocus(scroll);
    }

    private handleOnBlur = (regexPattern: string, onValidationFailure: Handler.Action) => (event: React.FocusEvent<HTMLInputElement>): void => {

        const value = event.currentTarget.value;

        if (!StringHelper.isUndefinedNullOrEmpty(value) && !StringHelper.isRegexMatch(value, regexPattern)) {
            onValidationFailure();
        }
    }

    private handleOnChange = (onChangeCallback: Handler.StringProperty, propertyName: string) => (event: React.FormEvent<HTMLInputElement>) => {

        const newValue = (event.target as HTMLInputElement).value;
        onChangeCallback(newValue.toUpperCase(), propertyName);
    }

    render() {

        const { isDisabled, isHidden, onBlurCallback, onChangeCallback, onKeyPressCallback, onValidationFailure, placeholder, propertyName, regexPattern, tabIndex, value } = this.props;

        const inputProps: IInternalCommonTextInputProps = {
            appendedInputClassName: 'text-uppercase',
            isDisabled,
            isHidden,
            maxLength: 7,
            onBlurCallback: this.handleOnBlur(regexPattern, onValidationFailure),
            onChangeCallback: this.handleOnChange(onChangeCallback, propertyName),
            onKeyPressCallback,
            placeholder,
            propertyName,
            ref: (component: InternalCommonTextInput) => { this.primaryInput = component; },
            tabIndex,
            value
        };

        return (
            <InternalCommonTextInput {...inputProps} />
        );
    }
}

const hotSimplePostalCodeInput = hot(module)(SimplePostalCodeInput);

export {
    hotSimplePostalCodeInput as SimplePostalCodeInput,
    ISimplePostalCodeInputProps
};
